"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoFocusOutline = void 0;
var styled_components_1 = require("styled-components");
exports.NoFocusOutline = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.noFocusOutline &&
        "\n    html {\n      a:focus,\n      button:focus,\n      div[role='button']:focus {\n        outline: none;\n      }\n    }\n    ";
});
var templateObject_1;
//# sourceMappingURL=NoFocusOutline.js.map